export enum TIME_TICKET_WEEK_STEP {
	TempWorker = 0,
	Client = 1,
	Agency = 2,
	AgencyIntegrated = 3,
}
